import React, { useEffect, useState } from "react";
import { useMsal, useAccount } from "@azure/msal-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as ratingService from "../../../mydnv/services/rating-service";
import { Config } from "config";
import { MenuItem, ListItemText, Select, Checkbox, InputLabel, FormControl, FormControlLabel } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { solid } from "assets/icons";
const { faTriangleExclamation, faCircleCheck } = solid;

export const RateMyExperience = () => {
    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0] || {});

    const loginRequest = Config.MyDNV.loginRequest;

    const [formData, setFormData] = useState({
        rating: 0,
        comments: "",
        followup: false,
        reasons: [],
    });

    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState(false);

    const reasonOptions = [
        { label: "Subscriptions", value: 1 },
        { label: "Pages I'm watching", value: 2 },
        { label: "Bookmarks", value: 3 },
        { label: "Report a problem", value: 4 },
        { label: "Other", value: 5 },
    ];

    const theme = createTheme({
        components: {
            // Name of the component ⚛️
            MuiButtonBase: {
                defaultProps: {
                    // The props to apply
                    disableRipple: true, // No more ripple, on the whole application 💣!
                },
            },
        },
        transitions: {
            // So `transition: none;` gets applied everywhere
            create: () => "none",
        },
    });

    // useEffect(() => {
    //     console.log(instance);
    // }, [instance]);

    const handleChange = (e) => {
        if (e.target.name === "comments") {
            setFormData({ ...formData, [e.target.name]: e.target.value });
        } else if (e.target.name === "rating") {
            const isChecked = e.target.checked;
            if (isChecked) {
                setFormData({ ...formData, rating: e.target.value });
            }
        } else if (e.target.name === "followUp") {
            const isChecked = e.target.checked;
            setFormData({ ...formData, followup: isChecked });
        } else if (e.target.name === "reasons") {
            // console.log(e.target.value);
            setFormData({ ...formData, [e.target.name]: [...e.target.value] });
        }
    };

    const getAccessToken = () => {
        const request = {
            ...loginRequest,
            account: account,
        };

        instance
            .acquireTokenSilent(request)
            .then((response) => {
                postRating({
                    token: response.accessToken,
                    rating: formData.rating,
                    comments: formData.comments,
                    followup: formData.followup,
                    visit_reasons: formData.reasons.join(","),
                });
            })
            // eslint-disable-next-line no-unused-vars
            .catch((e) => {
                instance
                    .acquireTokenRedirect(request)
                    .then((response) => {
                        postRating({
                            token: response.accessToken,
                            rating: formData.rating,
                            comments: formData.comments,
                            followup: formData.followup,
                            visit_reasons: formData.reasons.join(","),
                        });
                    })
                    .catch((error) => console.error(error));
            });
    };

    const postRating = async (args) => {
        try {
            await ratingService.postRating(args).then(() => {
                setError(false);
                setSubmitted(true);
            });
        } catch (error) {
            setSubmitted(true);
            setError(true);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        getAccessToken();
    };

    return (
        <div>
            <h2 className="cardTitle">Rate your experience</h2>
            {(submitted === false || (submitted === true && error)) && (
                <div className="rateMyExperience">
                    <p className="bold">How would you rate your MyDNV experience?</p>
                    <form onSubmit={handleSubmit}>
                        <div className="experience-emojis">
                            <div className="label-wrapper">
                                <div className="emoji">
                                    <input type="radio" id="rating1" name="rating" value="1" onChange={handleChange} />
                                    <label
                                        htmlFor="rating1"
                                        className={Number(formData.rating) === 1 ? "selected" : ""}
                                    >
                                        😠
                                    </label>
                                </div>
                                Very poor
                            </div>
                            <div className="label-wrapper">
                                <div className="emoji">
                                    <input type="radio" id="rating2" name="rating" value="2" onChange={handleChange} />
                                    <label
                                        htmlFor="rating2"
                                        className={Number(formData.rating) === 2 ? "selected" : ""}
                                    >
                                        ☹️
                                    </label>
                                </div>
                                Poor
                            </div>
                            <div className="label-wrapper">
                                <div className="emoji">
                                    <input type="radio" id="rating3" name="rating" value="3" onChange={handleChange} />
                                    <label
                                        htmlFor="rating3"
                                        className={Number(formData.rating) === 3 ? "selected" : ""}
                                    >
                                        😑
                                    </label>
                                </div>
                                Average
                            </div>
                            <div className="label-wrapper">
                                <div className="emoji">
                                    <input type="radio" id="rating4" name="rating" value="4" onChange={handleChange} />
                                    <label
                                        htmlFor="rating4"
                                        className={Number(formData.rating) === 4 ? "selected" : ""}
                                    >
                                        🙂
                                    </label>
                                </div>
                                Good
                            </div>
                            <div className="label-wrapper">
                                <div className="emoji">
                                    <input type="radio" id="rating5" name="rating" value="5" onChange={handleChange} />{" "}
                                    <label
                                        htmlFor="rating5"
                                        className={Number(formData.rating) === 5 ? "selected" : ""}
                                    >
                                        😃
                                    </label>
                                </div>
                                Excellent
                            </div>
                        </div>
                        {Number(formData.rating) > 0 && (
                            <>
                                <div className="row mt">
                                    <label className="bold" htmlFor="reason">
                                        What brought you here today?
                                        <ThemeProvider theme={theme}>
                                            <FormControl sx={{ m: 1 }}>
                                                <InputLabel
                                                    id="select-label"
                                                    className={`${formData.reasons.length > 0 ? "hidden" : ""}`}
                                                >
                                                    Select all that apply
                                                </InputLabel>
                                                <Select
                                                    multiple
                                                    className="experience-select"
                                                    name="reasons"
                                                    value={formData.reasons}
                                                    label="Select all that apply"
                                                    labelId="select-label"
                                                    MenuProps={{
                                                        PaperProps: {
                                                            className: "filter-dropdown-popover",
                                                        },
                                                    }}
                                                    onChange={handleChange}
                                                >
                                                    {reasonOptions.map((reason, index) => (
                                                        <MenuItem
                                                            key={index}
                                                            value={reason.value}
                                                            multiple
                                                            disableRipple
                                                            className="reasons"
                                                        >
                                                            <Checkbox
                                                                checked={formData.reasons.includes(reason.value)}
                                                                className="exp-reasons"
                                                            />
                                                            <ListItemText primary={reason.label} />
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </ThemeProvider>
                                    </label>
                                </div>
                                <div className="row mt">
                                    <label className="bold">
                                        Let us know more about your experience (optional)
                                        <textarea name="comments" id="comments" onChange={handleChange}></textarea>
                                    </label>
                                </div>
                                <div className="row">
                                    <ThemeProvider theme={theme}>
                                        <FormControlLabel
                                            className="follow-up"
                                            control={
                                                <Checkbox
                                                    checked={formData.followUp}
                                                    className="followUp"
                                                    onChange={handleChange}
                                                    name="followUp"
                                                />
                                            }
                                            label="You have my permission to contact me if you want to hear more about my
                                        experience."
                                        />
                                    </ThemeProvider>
                                </div>
                                <button type="button" className="btn" onClick={getAccessToken}>
                                    Submit feedback
                                </button>
                            </>
                        )}
                    </form>
                    {submitted && error && (
                        <div className="submitted error">
                            <FontAwesomeIcon icon={faTriangleExclamation} />
                            <p>Something went wrong, please try again.</p>
                        </div>
                    )}
                </div>
            )}
            {submitted && error === false && (
                <div className="rateMyExperience">
                    <div className="submitted">
                        <FontAwesomeIcon icon={faCircleCheck} />
                        <p>Thank you for your feedback!</p>
                    </div>
                </div>
            )}
        </div>
    );
};
